import { useQuery } from '@tanstack/react-query';

import API from '@/config/api';

import type { Me, Permissions } from './Permissions.types';

const GATEWAY_URL = process.env.BUSINESS_AP_API;

// The permissions service is reached through the API gateway, not the admin API base URL.
export const permissionsUrl = (resource: string) =>
	`${GATEWAY_URL}/bizops-user-permissions/api/v1/permissions?permission=${resource}`;

export const useMe = () =>
	useQuery<Me>({
		queryKey: ['permissions_service', 'me'],
		queryFn: async () => API.get<Me>(`${GATEWAY_URL}/bizops-user-permissions/api/v1/me`).then((res) => res.data),
	});

export const usePermissionsQuery = () =>
	useQuery<Permissions>({
		queryKey: ['permissions_service', 'aiAgents'],
		queryFn: async () => API.get<Permissions>(permissionsUrl('aiAgents')).then((res) => res.data),
	});
